import styled from "styled-components";
import { ThemeColors } from "redux/hooks";

export const MarkdownViewerWrapper = styled.div<{ darkMode?: boolean; greyText?: boolean; themeColors?: ThemeColors }>`
  /* Prevent content from overflowing flex containers */
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;

  h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
    word-break: break-word;
  }

  p {
    overflow-wrap: break-word;
    word-break: break-word;
  }

  pre {
    overflow-x: auto;
    max-width: 100%;
  }

  /* Code block background - adapts to dark mode */
  .hljs {
    background: ${props => props.darkMode ? (props.themeColors?.backgroundColorSecondary || '#282c34') : '#ffffff'} !important;
  }

  table {
    border-collapse: collapse;
    margin: 0.5em 0;
  }

  th, td {
    border: 1px solid ${props => props.darkMode ? (props.themeColors?.borderColor || '#404040') : '#CCCCCC'};
    text-align: left;
    padding: 0.25em 1em;
    color: ${props => props.darkMode ? (props.themeColors?.textColor || '#ffffff') : 'inherit'};
  }

  th {
    background-color: ${props => props.darkMode ? (props.themeColors?.backgroundColor || '#1f1f1f') : 'transparent'};
  }


  // SQL syntax highlighting
  .sql-keyword {
    color: ${props => props.darkMode ? '#569cd6' : '#0000ff'};
    font-weight: 600;
  }
  .sql-string {
    color: ${props => props.darkMode ? '#ce9178' : '#a31515'};
  }
  .sql-number {
    color: ${props => props.darkMode ? '#b5cea8' : '#098658'};
  }
  .sql-comment {
    color: ${props => props.darkMode ? '#6a9955' : '#008000'};
    font-style: italic;
  }

  /* Dark mode text colors */
  ${props => props.darkMode ? `
    color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
    h1, h2, h3, h4, h5, h6 {
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
    }
    p {
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
    }
    a {
      color: ${props.themeColors?.primaryColorLight || '#4A9EFF'};
    }
    a:hover {
      color: ${props.themeColors?.primaryColorHover || '#6bb3ff'};
    }
    strong {
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
    }
    ul, ol {
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
    }
    blockquote {
      border-left: 4px solid ${props.themeColors?.borderColor || '#404040'};
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColorSecondary || '#cccccc')};
      background-color: ${props.themeColors?.backgroundColorSecondary || '#2d2d2d'};
    }
    code:not(.hljs) {
      background-color: ${props.themeColors?.backgroundColorSecondary || '#2d2d2d'};
      color: ${props.greyText ? (props.themeColors?.textColorMuted || '#888888') : (props.themeColors?.textColor || '#ffffff')};
      border: 1px solid ${props.themeColors?.borderColor || '#404040'};
    }
  ` : props.greyText ? `
    color: #666666;
    h1, h2, h3, h4, h5, h6 {
      color: #666666;
    }
    p {
      color: #666666;
    }
    a {
      color: #888888;
    }
    a:hover {
      color: #666666;
    }
    strong {
      color: #666666;
    }
    ul, ol {
      color: #666666;
    }
    blockquote {
      color: #666666;
      border-left: 4px solid #d9d9d9;
      background-color: #f7f7f7;
    }
    code:not(.hljs) {
      color: #666666;
    }
  ` : ''}
  `;